import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'
import { func } from 'prop-types'

function* loadExcessExpenses(action) {
    const {
        data: {
          page,
          pageSize,
          orderBy,
          orderType,
          accessToken,
          company_id,
          filterObj,
          type,
          file_value_pdf,
          limit_export,
        },
    } = action.payload

    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-excess-expenses-lists`,
            {
              page,
              pageSize,
              orderBy,
              orderType,
              company_id,
              filterObj,
              type,
              file_value_pdf,
              limit_export,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
          yield put(actions.loadExcessExpenses.success(res.data, page))
    } catch (err) {
        console.log(err.message)
        yield put(actions.loadExcessExpenses.failure())
    }
}

function* exportExcessExpenses(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      accessToken,
      company_id,
      filterObj,
      type,
      file_value_pdf,
      limit_export,
    },
  } = action.payload
  try {
    const res = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-excess-expenses-lists`,
        {
          page,
          pageSize,
          orderBy,
          orderType,
          company_id,
          filterObj,
          type,
          file_value_pdf,
          limit_export,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } },
      )
      yield put(actions.exportExcessExpenses.success(res.data, page))
      const sftpPath = res.data.data
      const downloadRes = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
        { sftp_path: sftpPath },
        { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
      )
      const ext = sftpPath.split('.').pop().toLowerCase()
      const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const blob = new Blob([downloadRes.data], { type: mimeType })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = sftpPath.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
  } catch (err) {
      console.log(err.message)
      yield put(actions.exportExcessExpenses.failure())
  }
}

function* loadExcessExpensesDetail(action) {
    const {
        data: { id, accessToken },
    } = action.payload
    try {
        const res = yield call(
          axios.get,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-excess-expenses-detail/${id}`,
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )
        yield put(actions.loadExcessExpensesDetail.success(res.data))
      } catch (err) {
        console.log(err.message)
        yield put(actions.loadExcessExpensesDetail.failure())
      }
}

function* createExcessExpenses(action) {
  const {
    data: {
      id,
      overlaps_id,
      vehicle_type_id,
      isupply_excess_charge_form_pettern_id,
      companies_id,
      start_date,
      expired_date,
      form,
      accessToken
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/create-excess-expenses`,
      {
        id,
        overlaps_id,
        vehicle_type_id,
        isupply_excess_charge_form_pettern_id,
        companies_id,
        start_date,
        expired_date,
        form
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    loading(res.data)
    yield put(actions.createExcessExpenses.success(res.data))
  } catch (err) {
    yield put(actions.createExcessExpenses.failure())
  }
}

function* updateExcessExpenses(action) {
  const {
    data: {
      id,
      overlaps_id,
      vehicle_type_id,
      isupply_excess_charge_form_pettern_id,
      companies_id,
      start_date,
      expired_date,
      form,
      accessToken
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/update-excess-expenses`,
      {
        id,
        overlaps_id,
        vehicle_type_id,
        isupply_excess_charge_form_pettern_id,
        companies_id,
        start_date,
        expired_date,
        form
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    loading(res.data)
    yield put(actions.updateExcessExpenses.success(res.data))
  } catch (err) {
    yield put(actions.updateExcessExpenses.failure())
  }
}

export default function* watchExcessExpenses() {
    yield all([
        takeEvery(actions.LOAD_EXCESS_EXPENSES.REQUEST, loadExcessExpenses),
        takeEvery(actions.LOAD_EXCESS_EXPENSES_DETAIL.REQUEST, loadExcessExpensesDetail),
        takeEvery(actions.CREATE_EXCESS_EXPENSES.REQUEST, createExcessExpenses),
        takeEvery(actions.UPDATE_EXCESS_EXPENSES.REQUEST, updateExcessExpenses),
        takeEvery(actions.EXPORT_EXCESS_EXPENSES.REQUEST, exportExcessExpenses),
    ])
}

export {
    loadExcessExpenses,
    loadExcessExpensesDetail,
    createExcessExpenses,
    updateExcessExpenses,
    exportExcessExpenses
}